var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-col',{staticClass:"mb-24",attrs:{"cols":"12"}},[(!_vm.loading && _vm.initSeries[0].data.length)?_c('apexchart',{attrs:{"height":"350","type":"bar","options":_vm.options,"series":_vm.series}}):_c('div',{staticClass:"text-center"},[_c('h5',{staticClass:"mb-0"},[_c('b-spinner',{staticClass:"align-middle mr-8"})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }